import { Typography } from "@material-ui/core";
import React from "react";

import classes from "./FlightResultCard.module.css";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function FlightResultCard({
  route,
  tripType,
  cityTo,
  cityFrom,
}) {
  const departureDate = new Date(route.segments[0].utc_departure);
  const arrivalDate = new Date(
    route.segments[route.segments.length - 1].utc_arrival
  );
  const { duration } = route;
  const hr = Math.floor(duration / 3600);
  const min = Math.floor((duration / 3600 - hr) * 60);

  function formatHourString(time) {
    if (time < 10) return `0${time}`;
    return time;
  }

  const getStops = (segments) => {
    let count = 0;
    segments.forEach((segment) => {
      if (segment.return === 0) {
        count += 1;
      }
    });
    return count;
  };

  return (
    <div className={classes["flight-card"]}>
      <div className={classes["flight-card__head"]}>
        <div className={classes["airline-icons"]}>
          {route.segments
            .map((segment) => segment.operating_carrier || segment.airline)
            .map((airline) => (
              <img
                title={airline}
                height="30px"
                width="30px"
                src={`https://images.kiwi.com/airlines/64/${airline}.png`}
              />
            ))}
        </div>
        <Typography variant="h5">
          <strong style={{ fontSize: "1rem" }}>{tripType}</strong>{" "}
          <span style={{ fontSize: "1rem" }}>
            {departureDate.getDate()}{" "}
            {monthNames[departureDate.getMonth()].substring(0, 3)}
          </span>
        </Typography>
      </div>
      <div className={classes["flight-card__body"]}>
        <div style={{ alignSelf: "center" }}>
          <Typography
            variant="h4"
            style={{ fontSize: "1rem", fontWeight: 700 }}
          >
            {formatHourString(departureDate.getHours())}:
            {formatHourString(departureDate.getMinutes())}
          </Typography>
          <Typography
            variant="p"
            style={{ fontSize: "13px", fontWeight: 500, color: "#222222" }}
          >
            {cityFrom}
          </Typography>
        </div>
        <div style={{ alignSelf: "center", flexBasis: "25%" }}>
          <Typography variant="p" className={classes["time-heading"]}>
            <strong>{formatHourString(hr)}</strong>{" "}
            <span style={{ color: "#999999" }}>h</span>{" "}
            <strong>{formatHourString(min)}</strong>{" "}
            <span style={{ color: "#999999" }}>m</span>{" "}
          </Typography>
          <Typography
            variant="p"
            style={{
              display: "block",
              padding: "0.25rem",
              fontWeight: 500,
              color: "#6E7277",
              fontSize: "13px",
            }}
          >
            {route.segments.length - 1} stops
          </Typography>
        </div>
        <div style={{ alignSelf: "center" }}>
          <Typography
            variant="h4"
            style={{ fontSize: "1rem", fontWeight: 700 }}
          >
            {formatHourString(arrivalDate.getHours())}:
            {formatHourString(arrivalDate.getMinutes())}
          </Typography>
          <Typography
            variant="p"
            style={{ fontSize: "13px", fontWeight: 500, color: "#222222" }}
          >
            {cityTo}
          </Typography>
        </div>
      </div>
    </div>
  );
}
